import React from 'react';
import PropTypes from 'prop-types';

import { TERMS_OF_SERVICE_URL } from '../constants';

const TermsOfServiceModal = ({ onSubmit, onCancel }) => (
  <div className="terms-of-service-modal">
    <h2>Terms of Service</h2>
    <ul>
      <li>Payments sent via Tabby Pay must be accepted through pay.tabby.io.</li>
      <li>
        The recipient&apos;s wallet must be a{' '}
        <a
          href="https://support.blockcat.io/hc/en-us/articles/360001688712"
          target="_blank"
          rel="noopener noreferrer"
        >
          supported wallet
        </a>.
      </li>
      <li>The payment cannot be cancelled once it has been accepted.</li>
    </ul>
    <div className="actions">
      <button type="button" name="back" className="btn cancel" onClick={onCancel}>
        Back
      </button>
      <button type="button" name="agree" className="btn" onClick={onSubmit}>
        I Accept
      </button>
    </div>
    <p className="secondary">
      <em>
        By clicking I ACCEPT you agree to our{' '}
        <a href={TERMS_OF_SERVICE_URL} target="_blank" rel="noopener noreferrer">
          terms of service.
        </a>
      </em>
    </p>
  </div>
);

TermsOfServiceModal.defaultProps = {
  onSubmit: () => null,
  onCancel: () => null,
};

TermsOfServiceModal.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

export default TermsOfServiceModal;



// WEBPACK FOOTER //
// ./src/components/TermsOfServiceModal.js